import styled, { css } from "styled-components"

const StyledWrapper = styled.div`
  padding: 8rem ${({ theme }) => theme.layout.mobilePadding} 4rem;
  margin: 0 auto;
  max-width: ${({ theme }) => theme.gridWidth};
`
const StyledSection = styled.div`
  margin: 2rem 0;
`
const paragraphStyles = css`
  p {
    margin: 1rem 0;
  }
`
export { StyledWrapper, StyledSection, paragraphStyles }
